import React from 'react';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { RefreshCallback } from '../../../FetchContainer';
import { PostTypes } from '../Post.types';
import { AcceptDeclineForm } from '../../../Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';
import { Hint } from '../../Hint';
import { SonForm } from '../../../Form2';

type PostDeleteForm = {
  id: string;
  closeModal: () => void;
  type: PostTypes;
  currentForm: SonForm<any>;
  refresh: RefreshCallback;
};

export function PostDeleteForm({ id, closeModal, type, currentForm, refresh }: PostDeleteForm) {
  const { t } = useSonTranslation('Posts');

  const onSuccess = () => {
    setTimeout(() => {
      refresh();
    }, 2000);
  };

  return (
    <ModalDialog
      key={`delete-modal-${id}`}
      initialFocusIndex={1}
      closeModal={closeModal}
      headline={t(`default.contextMenu.delete.${type}.title`)}
    >
      <AcceptDeclineForm
        id={`post-delete-form-${id}`}
        form={currentForm as any}
        headline={t(`default.contextMenu.delete.${type}.headline`)}
        onSuccess={onSuccess}
        messageSuccess={t(`default.contextMenu.delete.${type}.status.success`)}
        messageSending={t(`default.contextMenu.delete.${type}.status.sending`)}
        messageFail={t(`default.contextMenu.delete.${type}.status.fail`)}
      >
        {type !== 'reply' ? <Hint message={t(`default.contextMenu.delete.${type}.hint`)} /> : null}
      </AcceptDeclineForm>
    </ModalDialog>
  );
}
